export function errorSplit (error) {
  var errors = []
  if (error == null) {
    return errors
  }
  var splitErrors = error.split(';')
  for (let i = 0; i < splitErrors.length; i++) {
    if (splitErrors[i] !== '') {
      errors.push(splitErrors[i])
    }
  }
  return errors
}

export function getError (e) {
  let result = []
  try {
    if (e == null) {
      result.push('Bilinmeyen Bir Hata Oluştu')
    } else {
      if (e.status === 500) {
        result.push('Bilinmeyen Bir Hata Oluştu')
      } else if (e.status === 403) {
        result.push('Yetkiniz Bulunmamaktadır')
      } else if (e.status === 400) {
        result = errorSplit(e.data.message)
      } else if (e.status === 404) {
        result = errorSplit(e.data.message)
      } else {
        result.push('Bilinmeyen Bir Hata Oluştu')
      }
    }
  } catch (e) {
    result.push('İletişim Hatası Oluştu')
  }
  return result
}
